import {
  useCompanyNarratives,
  type Narrative,
} from '@/pages/Narrative/components/CompanyNarratives/hooks/useCompanyNarratives';
import { useMemo } from 'react';
import { useSponsoredNarratives } from '@/pages/Narrative/components/CompanyNarratives/hooks/useSponsoredNarratives';

export const useNarratives = ({ canonicalUrl }: { canonicalUrl: string }) => {
  const { data } = useCompanyNarratives({ canonicalUrl });
  const { data: sponsoredNarrativesData } = useSponsoredNarratives({
    companyId: data.company?.id,
  });

  const communityNarrativeCount = data.narratives.edges.length ?? 0;
  const shouldShowHistogram = data.company.valuationHistogram.primaryCount > 5;
  const narratives = useMemo(() => {
    const sponsoredNarratives =
      sponsoredNarrativesData.sponsoredNarratives ?? [];
    return [
      data.company.myValuation?.narrative,
      data.company.myNarrative,
      ...sponsoredNarratives,
      ...data.narratives.edges.map((edge) => edge.node),
    ].reduce((result, narrative) => {
      if (!narrative || result.some((item) => item.id === narrative.id))
        return result;

      return [...result, narrative];
    }, [] as Narrative[]);
  }, [data, sponsoredNarrativesData]);

  return {
    company: data.company,
    narratives,
    shouldShowHistogram,
    communityNarrativeCount,
  };
};
